export default {
  LOOKUP_FOLIO: 'app/expressCheckin/LOOKUP_FOLIO',
  LOOKUP_FOLIO_SUCCESS: 'app/expressCheckin/LOOKUP_FOLIO_SUCCESS',
  LOOKUP_FOLIO_FAIL: 'app/expressCheckin/LOOKUP_FOLIO_FAIL',
  SUBMIT_CHECKIN: 'app/expressCheckin/SUBMIT_CHECKIN',
  SUBMIT_CHECKIN_SUCCESS: 'app/expressCheckin/SUBMIT_CHECKIN_SUCCESS',
  SUBMIT_CHECKIN_FAIL: 'app/expressCheckin/SUBMIT_CHECKIN_FAIL',
};
